import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CorrespondenceActionPartyDto, CorrespondenceTeamDto, UserStaffDetailDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';


@Component({
  selector: 'cradua-correspondenceactionparty-container',
  templateUrl: './correspondenceactionparty-container.component.html',
  styleUrls: ['./correspondenceactionparty-container.component.scss']
})
export class CorrespondenceactionpartyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  correspondenceactionpartys$: Observable<CorrespondenceActionPartyDto[]>;
  correspondenceteam$: Observable<CorrespondenceTeamDto[]>;
  correspondencestaff$: Observable<UserStaffDetailDto[]>;
  loading: boolean;
  isLoadingCorrespondenceActionParty$: Observable<boolean>;
  isLoadingCorrespondenceTeam$: Observable<boolean>;
  isLoadingCorrespondenceStaff$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCorrespondenceActionParty$ = this.gatwayFacade.isLoadingGateway("CorrespondenceActionParty");
    this.isLoadingCorrespondenceTeam$ = this.gatwayFacade.isLoadingGateway("CorrespondenceTeam");
     this.isLoadingCorrespondenceStaff$ = this.gatwayFacade.isLoadingGateway("IdentityUser");

    this.correspondenceactionpartys$ = this.gatwayFacade.loadGateway("CorrespondenceActionParty");
    this.correspondenceteam$ = this.gatwayFacade.loadGateway("CorrespondenceTeam");
    this.correspondencestaff$ = this.gatwayFacade.loadGateway("IdentityUser");
    // this.gatwayFacade.loadGateway("IdentityUser").subscribe((data) => {
    //   console.log("Users ", data);
    // })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCorrespondenceActionParty(deletedValue: any) {
    this.gatwayFacade.remove("CorrespondenceActionParty", deletedValue);
  }


// this method control both the create and update

  onSubmitCorrespondenceActionParty(formValue: any) {

    const pullData = formValue.CorrespondenceActionPartys;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCorrespondenceActionParty = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCorrespondenceActionParty.push(pullData[i]);
    }
  }

// check if the addAllCorrespondenceActionParty array is not empty, then dispatch the data to the store
   if(addAllCorrespondenceActionParty.length > 0) {
    this.gatwayFacade.add('CorrespondenceActionParty', addAllCorrespondenceActionParty);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('CorrespondenceActionParty', allUpdates, ['id']);
  }

   }

}
